import { gql } from '@apollo/client';
export const APPROVAL_FIELDS = gql `
  fragment ApprovalFields on Approval {
    id
    clientId
    workflowId
    workflowTaskId
    workflowRunId
    workflowRunTaskId
    targetUserType
    isAssignedToGroup
    isFallback
    assignedTo
    status
    workflowType
    employeeName
    employeeId
    schoolName
    schoolCountryCode
    fieldOfStudyName
    programName
    programLevelName
    amountRequested
    amountApproved
    amountToPay
    amountEarmarked
    createdAt
    updatedAt
    submittedAt
    expirationDate
    workflowableId
    workflowableType
    workflowableStatus
    requestNum
    schoolId
    fieldOfStudyId
    startDate
    estCompDate
    clientName
    approvedBy
  }
`;
export const APPROVALS = gql `
  ${APPROVAL_FIELDS}
  query Approvals($spec: ApprovalSpec!) {
    approvals(spec: $spec) {
      total
      page
      pageSize
      items {
        ...ApprovalFields
      }
    }
  }
`;
export const CLAIMS_PROCESSOR_APPROVALS = gql `
  ${APPROVAL_FIELDS}
  query ClaimsProcessorApprovals($spec: ApprovalSpec!) {
    claimsProcessorApprovals(spec: $spec) {
      total
      page
      pageSize
      items {
        ...ApprovalFields
      }
    }
  }
`;
export const APPROVAL_COUNTS = gql `
  query ApprovalCounts($spec: ApprovalSpec!) {
    approvalCounts(spec: $spec) {
      workflowType
      count
    }
  }
`;
export const UPDATE_APPROVAL_TASK = gql `
  mutation UpdateApprovalTask($input: ApprovalTaskInput!) {
    updateApprovalTask(input: $input) {
      success
      message
    }
  }
`;
